import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../stores/types';
import { addToCart, removeFromCart } from '../../../stores/slices/CartSlice';
import { setSelectedProduct } from '../../../stores/slices/SelectedProductSlice';
// import { useState } from 'react';

// interface Produits {
//     id: number;
//     // titre: string;
//     category: Categorie;
//     type: ProductType;
//     name: string;
//     description: string;
//     spec: string;
//     price: number;
//     unit: string;
//     devis?: boolean;
//     badge: string;
//     tagline: string;
//     features: string[];
//     includes?: string[];
// }

// Simulation de la fonction de formatage (ex: 1500 -> 1 500 €)
const fmt = (price: number) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'FCFA' }).format(price);

interface Product {
  id: number;
  category: string;
  type: string;
  name: string;
  description: string;
  spec: string;
  price: number;
  unit: string;
  devis?: boolean;
  badge: string;
  tagline: string;
  features: string[];
  includes?: string[];
}

interface ProductGridProps {
  products: Product[];
  currentCat: string;
  currentFilter: string;
  searchText: string;
  cart: Record<number, number>;
  selectedId: number | null;
  onSelectProduct?: (id: number) => void;
}

const ProductGrid = ({ products, currentCat, currentFilter, searchText, cart, selectedId, onSelectProduct }: ProductGridProps) => {

  const dispatch = useDispatch();
  const cartItems = useSelector((state: ApplicationState) => state.cart.cartItems);
  const totalPrice = useSelector((state: ApplicationState) => state.cart.totalPrice);
  const selectedProduct = useSelector((state: ApplicationState) => state.selectedProduct.selectedProduct);

  // 1. Logique de filtrage (équivalent du début de votre fonction)
  const filteredList = useMemo(() => {
    return products.filter((p) => {
      if (currentCat !== 'Tous' && currentCat !== 'all' && p.category !== currentCat) return false;
      if (currentFilter !== 'Tous' && currentFilter !== 'all' && p.type !== currentFilter) return false;
      
      if (searchText) {
        const search = searchText.toLowerCase();
        const inName = p.name.toLowerCase().includes(search);
        const inSpec = p.spec.toLowerCase().includes(search);
        const inTagline = p.tagline.toLowerCase().includes(search);
        if (!inName && !inSpec && !inTagline) return false;
      }
      return true;
    });
  }, [products, currentCat, currentFilter, searchText]);

  // 2. Gestion de l'affichage vide
  if (filteredList.length === 0) {
    return <div className="empty">Aucun produit trouvé</div>;
  }

//   const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  
//     // Équivalent de openDetail(id)
//     const openDetail = (id: number) => {
//         const p = products.find(x => x.id === id);
//         if (p) setSelectedProduct(p);
//     };
  
//     // Équivalent de closeDetail()
//     const closeDetail = () => setSelectedProduct(null);

  // 3. Le Rendu (équivalent du grid.innerHTML)
  return (
    <div id="products-grid" className="products-grid">
      {filteredList.map((p: Product) => {
        const inCart = cartItems.some((item) => item.id === p.id);
        const isSelected = selectedId === p.id;
        const isSelectedInStore = selectedProduct;

        return (
          <div 
            key={p.id} 
            className={`product-card ${isSelected ? 'selected' : ''}`}
            onClick={() => {
              onSelectProduct?.(p.id);
            }}
          >
            {/* Badge de type */}
            <span className={`prod-badge ${p.badge}`}>
              {p.type === 'materiel' && 'Matériel'}
              {p.type === 'service' && 'Services'}
              {p.type === 'cloud' && 'Cloud'}
              {p.type === 'licence' && 'Licence'}
              {p.type === 'pack' && 'Packs'}
            </span>

            <div className="prod-name">{p.name}</div>
            <div className="prod-spec">{p.tagline}</div>

            {/* Affichage du prix ou devis */}
            {p.devis ? (
              <span className="devis-tag">Sur devis</span>
            ) : (
              <div className="price-container">
                <div className="prod-price">{p.price} FCFA</div>
                {p.unit && <div className="prod-recur">{p.unit}</div>}
              </div>
            )}

            <button 
              className={`add-btn ${inCart ? 'added' : ''}`}
              onClick={(e) => {
                e.stopPropagation(); // Empêche d'ouvrir le détail en cliquant sur le bouton
                // dispatch({ type: inCart ? 'cart/removeFromCart' : 'cart/addToCart', payload: { id: p.id, price: p.price } });
                dispatch(inCart ? removeFromCart({ id: p.id, price: p.price }) : addToCart({ id: p.id, price: p.price }));
              }}
            >
              {inCart ? 'Dans le devis' : '+ Ajouter'}
            </button>
          </div>
        );
      })}
    </div>

  );
};

export type { Product };
export default ProductGrid;